import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, RotateCcw } from 'lucide-react';
import confetti from 'canvas-confetti';

interface Props {
  email: string;
  onReset: () => void;
}

export default function SuccessScreen({ email, onReset }: Props) {
  useEffect(() => {
    const fire = () => {
      confetti({ particleCount: 80, spread: 70, origin: { y: 0.6 }, colors: ['#2563EB', '#10B981', '#0A1628'] });
      setTimeout(() => confetti({ particleCount: 60, spread: 100, origin: { y: 0.5 }, angle: 60 }), 250);
      setTimeout(() => confetti({ particleCount: 60, spread: 100, origin: { y: 0.5 }, angle: 120 }), 400);
    };
    fire();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-[100] flex items-center justify-center px-4"
      style={{ backgroundColor: '#F8FAFC' }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 200, damping: 20, delay: 0.1 }}
        className="bg-white rounded-3xl shadow-2xl p-10 max-w-md w-full text-center"
        style={{ boxShadow: '0 25px 60px rgba(0,0,0,0.12)' }}
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20, delay: 0.3 }}
          className="w-20 h-20 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <CheckCircle2 size={44} className="text-[#10B981]" />
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="text-2xl font-bold text-[#0F172A] mb-3"
          style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
        >
          ¡Consulta realizada con éxito!
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-[#64748B] mb-8"
        >
          Recibirás el informe en tu correo{' '}
          <span className="font-semibold text-[#0F172A]">{email}</span>{' '}
          en los próximos minutos.
        </motion.p>

        <motion.button
          data-testid="reset-btn"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onReset}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="w-full flex items-center justify-center gap-2 py-3 rounded-2xl font-bold text-white transition-all"
          style={{ backgroundColor: '#2563EB' }}
        >
          <RotateCcw size={18} />
          Realizar otra consulta
        </motion.button>
      </motion.div>
    </motion.div>
  );
}
